var mFOrderbookTransactionTypeMapper = function (response) {
    if (response.data.length > 0) {
        return response.data.sort(function (a, b) { return a.displayOrder - b.displayOrder; });
    }
};
export default mFOrderbookTransactionTypeMapper;
